<template>
  <section :id="id">
    <section-about-our-product title="ЛИЦЕНЗИИ И СЕРТИФИКАТЫ" :cards="[]" />
    <section-info />
  </section>
</template>

<script>
  // Extensions
  import View from '@/views/View'

  export default {
    name: 'Certificates',
    components: {
      SectionAboutOurProduct: () => import('@/views/sections/AboutOurProduct.vue'),
      SectionInfo: () => import('@/views/sections/Info.vue')
    },
    metaInfo: { title: 'Лицензии' },
    extends: View,
    props: {
      id: {
        type: String,
        default: 'pro',
      },
    },
  }
</script>
